export default import.meta.ROLLDOWN_FILE_URL_vYzL9oVtLmfR$5RMIYkFWQ